var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AfterViewInit, ElementRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Chart } from 'chart.js';
import 'chart.piecelabel.js';
import { ReportsApi } from '../../../api/reports-api';
import { ReportHelper } from '../../report-helper';
export class PlanningStatsTipReportComponent {
    constructor(reportsApi, reportHelper, route, titleService) {
        this.reportsApi = reportsApi;
        this.reportHelper = reportHelper;
        this.route = route;
        this.error = false;
        this.errorMessage = this.reportHelper.reportErrorMessages.noReportData;
        titleService.setTitle(titleService.getTitle() + ' : Planning Stats Tip Report');
    }
    ngAfterViewInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.route.paramMap.subscribe(x => {
                this.planningPartnerShortName = JSON.parse(window.localStorage.getItem(x.get('id'))).planningPartnerShortName;
                this.loadReport();
            });
        });
    }
    loadReport() {
        return this.reportsApi.getPlanningStatsTipReportData(this.planningPartnerShortName).then((reportData) => {
            this.reportData = reportData;
            this.createNonInterstateBridgeChart();
            this.createInterstateBridgeChart();
            this.createNonInterstateRoadChart();
            this.createInterstateRoadChart();
            this.insertDeckAreaCommas(reportData.planningStatsTipData);
        }, (error) => {
            this.error = true;
        });
    }
    // deck area numbers get really hard to read, inserting commas. We have to do this after
    // rendering charts otherwise chart doesn't display toolips correctly.
    insertDeckAreaCommas(data) {
        for (const key in data) {
            if (data[key].da) {
                data[key].da = data[key].da.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            }
        }
    }
    createNonInterstateBridgeChart() {
        const ctx = this.nonInterstateBridgesChartCanvasRef.nativeElement.getContext('2d');
        const _myChart = new Chart(ctx, {
            type: 'pie',
            data: {
                labels: ['Structurally Deficient, Programed, Construction Phase',
                    'Structurally Deficient, Programmed, Other Phase',
                    'Structurally Deficient, Not Programmed',
                    'Functionally Obselete, Programmed, Construction Phase',
                    'Functionally Obselete, Programmed, Other Phase',
                    'Functionally Obselete, Not Programmed',
                    'Good'],
                datasets: [{
                        label: 'Deck Area',
                        data: this.getNonInterstateBridgeArea(),
                        backgroundColor: [
                            'rgba(255, 99, 132, 0.7)',
                            'rgba(54, 162, 235, 0.7)',
                            'rgba(255, 206, 86, 0.7)',
                            'rgba(75, 192, 192, 0.7)',
                            'rgba(153, 102, 255, 0.7)',
                            'rgba(255, 159, 64, 0.7)',
                            'rgba(0, 105, 28, 0.7)'
                        ],
                        borderColor: [
                            'rgba(255,99,132,1)',
                            'rgba(54, 162, 235, 1)',
                            'rgba(255, 206, 86, 1)',
                            'rgba(75, 192, 192, 1)',
                            'rgba(153, 102, 255, 1)',
                            'rgba(255, 159, 64, 1)',
                            'rgba(0, 105, 28, 1)'
                        ],
                        borderWidth: 1
                    }]
            },
            options: {
                responsive: true,
                layout: {
                    padding: 20
                },
                legend: {
                    display: false
                },
                pieceLabel: {
                    render: 'percentage',
                    fontColor: '#000',
                    fontSize: 12,
                    position: 'outside',
                    format(value) {
                        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                    }
                }
            }
        });
    }
    createInterstateBridgeChart() {
        const ctx = this.interstateBridgesChartRef.nativeElement.getContext('2d');
        const _myChart = new Chart(ctx, {
            type: 'pie',
            data: {
                labels: ['Structurally Deficient, Programed, Construction Phase',
                    'Structurally Deficient, Programmed, Other Phase',
                    'Structurally Deficient, Not Programmed',
                    'Functionally Obselete, Programmed, Construction Phase',
                    'Functionally Obselete, Programmed, Other Phase',
                    'Functionally Obselete, Not Programmed',
                    'Good'],
                datasets: [{
                        label: 'Deck Area',
                        data: this.getInterstateBridgeArea(),
                        backgroundColor: [
                            'rgba(255, 99, 132, 0.7)',
                            'rgba(54, 162, 235, 0.7)',
                            'rgba(255, 206, 86, 0.7)',
                            'rgba(75, 192, 192, 0.7)',
                            'rgba(153, 102, 255, 0.7)',
                            'rgba(255, 159, 64, 0.7)',
                            'rgba(0, 105, 28, 0.7)'
                        ],
                        borderColor: [
                            'rgba(255,99,132,1)',
                            'rgba(54, 162, 235, 1)',
                            'rgba(255, 206, 86, 1)',
                            'rgba(75, 192, 192, 1)',
                            'rgba(153, 102, 255, 1)',
                            'rgba(255, 159, 64, 1)',
                            'rgba(0, 105, 28, 1)'
                        ],
                        borderWidth: 1
                    }]
            },
            options: {
                layout: {
                    padding: 20
                },
                legend: {
                    display: false
                },
                pieceLabel: {
                    mode: 'percentage',
                    fontColor: '#000',
                    fontSize: 12,
                    position: 'outside',
                    format(value) {
                        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                    }
                }
            }
        });
    }
    createInterstateRoadChart() {
        const ctx = this.interstateRoadStatusRef.nativeElement.getContext('2d');
        const _myChart = new Chart(ctx, {
            type: 'pie',
            data: {
                labels: ['Excellent and Good Not Addressed',
                    'Excellent and Good on Current TIP',
                    'Excellent and Good on Draft TIP',
                    'Fair Not Addressed',
                    'Fair on Current TIP',
                    'Fair on Draft TIP',
                    'Poor Not Addressed',
                    'Poor on Current TIP',
                    'Poor on Draft TIP',
                    'Invalid/Unknown IRI Not Addressed',
                    'Invalid/Unknown IRI on Current TIP',
                    'Invalid/Unknown IRI on Draft TIP'],
                datasets: [{
                        label: 'Miles',
                        data: this.getInterstateRoadMiles(),
                        backgroundColor: [
                            'rgba(255, 99, 132, 0.7)',
                            'rgba(54, 162, 235, 0.7)',
                            'rgba(255, 206, 86, 0.7)',
                            'rgba(75, 192, 192, 0.7)',
                            'rgba(153, 102, 255, 0.7)',
                            'rgba(255, 159, 64, 0.7)',
                            'rgba(0, 105, 28, 0.7)',
                            'rgba(221, 111, 0, 0.7)',
                            'rgba(153, 0, 0, 0.7)',
                            'rgba(160, 160, 160, 0.7)',
                            'rgba(128, 128, 128, 0.7)',
                            'rgba(96, 96, 96, 0.7)'
                        ],
                        borderColor: [
                            'rgba(255, 99, 132, 1)',
                            'rgba(54, 162, 235, 1)',
                            'rgba(255, 206, 86, 1)',
                            'rgba(75, 192, 192, 1)',
                            'rgba(153, 102, 255, 1)',
                            'rgba(255, 159, 64, 1)',
                            'rgba(0, 105, 28, 1)',
                            'rgba(221, 111, 0, 1)',
                            'rgba(153, 0, 0, 1)',
                            'rgba(160, 160, 160, 1)',
                            'rgba(128, 128, 128, 1)',
                            'rgba(96, 96, 96, 1)'
                        ],
                        borderWidth: 1
                    }]
            },
            options: {
                layout: {
                    padding: 20
                },
                legend: {
                    display: false
                },
                pieceLabel: {
                    mode: 'percentage',
                    fontColor: '#000',
                    position: 'outside',
                    format(value) {
                        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                    }
                }
            }
        });
    }
    createNonInterstateRoadChart() {
        const ctx = this.nonInterstateRoadStatusRef.nativeElement.getContext('2d');
        const _myChart = new Chart(ctx, {
            type: 'pie',
            data: {
                labels: ['Excellent and Good Not Addressed',
                    'Excellent and Good on Current TIP',
                    'Excellent and Good on Draft TIP',
                    'Fair Not Addressed',
                    'Fair on Current TIP',
                    'Fair on Draft TIP',
                    'Poor Not Addressed',
                    'Poor on Current TIP',
                    'Poor on Draft TIP',
                    'Invalid/Unknown IRI Not Addressed',
                    'Invalid/Unknown IRI on Current TIP',
                    'Invalid/Unknown IRI on Draft TIP'],
                datasets: [{
                        label: 'Miles',
                        data: this.getNonInterstateRoadMiles(),
                        backgroundColor: [
                            'rgba(255, 99, 132, 0.7)',
                            'rgba(54, 162, 235, 0.7)',
                            'rgba(255, 206, 86, 0.7)',
                            'rgba(75, 192, 192, 0.7)',
                            'rgba(153, 102, 255, 0.7)',
                            'rgba(255, 159, 64, 0.7)',
                            'rgba(0, 105, 28, 0.7)',
                            'rgba(221, 111, 0, 0.7)',
                            'rgba(153, 0, 0, 0.7)',
                            'rgba(160, 160, 160, 0.7)',
                            'rgba(128, 128, 128, 0.7)',
                            'rgba(96, 96, 96, 0.7)'
                        ],
                        borderColor: [
                            'rgba(255, 99, 132, 1)',
                            'rgba(54, 162, 235, 1)',
                            'rgba(255, 206, 86, 1)',
                            'rgba(75, 192, 192, 1)',
                            'rgba(153, 102, 255, 1)',
                            'rgba(255, 159, 64, 1)',
                            'rgba(0, 105, 28, 1)',
                            'rgba(221, 111, 0, 1)',
                            'rgba(153, 0, 0, 1)',
                            'rgba(160, 160, 160, 1)',
                            'rgba(128, 128, 128, 1)',
                            'rgba(96, 96, 96, 1)'
                        ],
                        borderWidth: 1
                    }]
            },
            options: {
                layout: {
                    padding: 20
                },
                legend: {
                    display: false
                },
                pieceLabel: {
                    mode: 'percentage',
                    fontColor: '#000',
                    position: 'outside',
                    format(value) {
                        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                    }
                }
            }
        });
    }
    // sending bridge area data to pie chart array
    getNonInterstateBridgeArea() {
        const area = [];
        const data = this.reportData.planningStatsTipData;
        for (const key in data) {
            if (data[key].cat !== 'TOTAL' && data[key].interstateInd === 'N' && data[key].posted === 'N') {
                if (data[key].pctDa) {
                    const x = parseFloat(data[key].pctDa);
                    area.push(x);
                }
                else {
                    area.push('0');
                }
            }
        }
        return area;
    }
    // sending bridge area data to pie chart array
    getInterstateBridgeArea() {
        const area = [];
        const data = this.reportData.planningStatsTipData;
        for (const key in data) {
            if (data[key].cat !== 'TOTAL' && data[key].interstateInd === 'Y' && data[key].posted === 'N') {
                if (data[key].pctDa) {
                    const x = parseFloat(data[key].pctDa);
                    area.push(x);
                }
                else {
                    area.push('0');
                }
            }
        }
        return area;
    }
    // sending miles data to pie chart array also calculating total miles for table
    getNonInterstateRoadMiles() {
        const miles = [];
        let totalMiles = 0;
        const data = this.reportData.nonInterstateRoadMiles;
        for (const key of Object.keys(data)) {
            if (data[key].unaddressed) {
                const x = parseFloat(data[key].unaddressed);
                miles.push(x);
                totalMiles += x;
            }
            else {
                miles.push('0');
            }
            if (data[key].tip) {
                const x = parseFloat(data[key].tip);
                miles.push(x);
                totalMiles += x;
            }
            else {
                miles.push('0');
            }
            if (data[key].draft) {
                const x = parseFloat(data[key].draft);
                miles.push(x);
                totalMiles += x;
            }
            else {
                miles.push('0');
            }
        }
        this.totalNonInterstateMiles = (totalMiles).toFixed(2);
        return miles;
    }
    // sending miles data to pie chart array also calculating total miles for table
    getInterstateRoadMiles() {
        const miles = [];
        let totalMiles = 0;
        const data = this.reportData.interstateRoadMiles;
        for (const key of Object.keys(data)) {
            if (data[key].unaddressed) {
                const x = parseFloat(data[key].unaddressed);
                miles.push(x);
                totalMiles += x;
            }
            else {
                miles.push('0');
            }
            if (data[key].tip) {
                const x = parseFloat(data[key].tip);
                miles.push(x);
                totalMiles += x;
            }
            else {
                miles.push('0');
            }
            if (data[key].draft) {
                const x = parseFloat(data[key].draft);
                miles.push(x);
                totalMiles += x;
            }
            else {
                miles.push('0');
            }
        }
        this.totalInterstateMiles = (totalMiles).toFixed(2);
        return miles;
    }
}
